import React from 'react';
import { connect } from 'redux-bundler-react';
import { BasicToolbarButton } from '../../application-controls';

class ZoomToBoxButton extends React.Component {
  // constructor(props){
  //   super(props);
  //   this.activate = this.activate.bind(this);
  //   this.deactivate = this.deactivate.bind(this);
  //   this.onBoxend = this.onBoxend.bind(this);
  // }

  // onBoxend(e){
  //   const { doZoomToExtent } = this.props;
  //   const extent = this.interaction.getGeometry().getExtent();
  //   doZoomToExtent(extent);
  // }

  // activate(){
  //   const { doSetInteraction, doSetCursor } = this.props;
  //   doSetCursor('zoom-in')
  //   this.interaction = createInteraction({
  //     interaction: 'dragbox',
  //     on:[{
  //       event: 'boxend',
  //       listener: this.onBoxend
  //     }]
  //   })
  //   doSetInteraction(this.interaction)
  // }

  // deactivate(){
  //   const { doUnsetInteractions, doSetCursor } = this.props;
  //   doSetCursor();
  //   doUnsetInteractions();
  // }

  render(){
    const { doStartZoomBox, doStopZoomBox, threeD } = this.props;
    return (
      <BasicToolbarButton
        enabled={true}
        iconClass='ms ms-zoom-box'
        iconStyle={{}}
        disabled={threeD}
        title="Zoom to custom extent"
        onActivate={ doStartZoomBox }
        onDeactivate={ doStopZoomBox }
      />
    )
  }
}

export default connect(
  'selectThreeD',
  'doStartZoomBox',
  'doStopZoomBox',
  ZoomToBoxButton
);